import {useMutation, useQueryClient} from '@tanstack/react-query'

import {createContractType, updateContractType} from './api'
import {contractTypeKeys} from './keys'
import {ContractTypeRequest, ContractTypeResponse} from './types'

export const useCreateContractType = () => {
  const queryClient = useQueryClient()

  return useMutation<ContractTypeResponse, unknown, ContractTypeRequest>({
    mutationFn: createContractType,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: contractTypeKeys.lists()})
    },
  })
}

export const useUpdateContractType = () => {
  const queryClient = useQueryClient()

  return useMutation<ContractTypeResponse, unknown, {id: string; body: ContractTypeRequest}>({
    mutationFn: ({id, body}) => updateContractType(id, body),
    onSuccess: (_, {id}) => {
      queryClient.invalidateQueries({queryKey: contractTypeKeys.detail(id)})
      queryClient.invalidateQueries({queryKey: contractTypeKeys.lists()})
    },
  })
}
